import {
  Button,
  Checkbox,
  DatePicker,
  Icon,
  InputDropdown,
  Section,
  useLanguageSelector,
  useToast,
} from '@vallourec-ui/vallourec-ui'
import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import moment from 'moment'

import { useNavigate, useSearchParams } from 'react-router-dom'

import { isAxiosError } from 'axios'

import {
  document as documentPost,
  documentApproval as documentApprovalPost,
} from '@/api/post'

import {
  ButtonContainer,
  CheckboxContainer,
  DropdownContent,
  FilterContainer,
  Row,
  SearchBarContainer,
  StyledButton,
  StyledInputLabel,
  StyledTextButton,
} from './style'
import { TESTS } from '@/utils/constants'

import DataToResult from '../DataToResult'
import HistoryModal from '../HistoryModal'
import ViewModal from '../ViewModal'
import TextFieldInput from '@/components/TextFieldInput'
import { useApp } from '@/stores/AppStore'
import { useDocumentApproval } from '@/stores/DocumentApprovalStore'
import {
  downloadBase64,
  downloadFile,
  extractFileNameByPath,
  getActionTranslate,
  getFilesByPaths,
} from '@/utils/utils'

const FilterSection: React.FC = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const navigate = useNavigate()
  const {
    setIsLoading,
    setDocCode,
    docCode,
    setStartDateApprovalFlow,
    setEndDateApprovalFlow,
    setProcessOrderItemsApprovalFlow,
    setPqLotItemsApprovalFlow,
  } = useApp()
  const {
    setTemplateRowResult,
    setItemsResult,
    isRealoadItemsResult,
    setIsRealoadItemsResult,
    itemsResult,
  } = useDocumentApproval()
  const { currentLanguage } = useLanguageSelector()
  const [additionModalIsOpen, setAdditionModalIsOpen] = useState(false)
  const [viewModalIsOpen, setViewModalIsOpen] = useState(false)
  const [doc, setDoc] = useState<any | undefined>(undefined)

  const [field, setField] = React.useState<string | undefined>(undefined)
  const [fieldText, setFieldText] = React.useState<string>('')
  const mappedFields = [
    {
      key: 0,
      value: 'test_type',
      label: t('searchReport.dataResult.test_type_doc'),
    },
    {
      key: 1,
      value: 'test_name',
      label: t('searchReport.dataResult.test_name'),
    },
    {
      key: 2,
      value: 'order_item',
      label: t('searchReport.dataResult.order_item'),
    },
    { key: 3, value: 'code_view', label: t('searchReport.dataResult.code') },
    { key: 4, value: 'action', label: t('searchReport.dataResult.status') },
    {
      key: 5,
      value: 'analyst_name',
      label: t('searchReport.dataResult.analyst_name'),
    },
    { key: 6, value: 'date', label: t('searchReport.dataResult.started_on') },
    {
      key: 7,
      value: 'checker_name',
      label: t('searchReport.dataResult.checker_name'),
    },
    {
      key: 8,
      value: 'checked_date',
      label: t('searchReport.dataResult.checked_started_on'),
    },
    {
      key: 9,
      value: 'approver_name',
      label: t('searchReport.dataResult.approver_name'),
    },
    {
      key: 10,
      value: 'approval_date',
      label: t('searchReport.dataResult.approval_started_on'),
    },
    {
      key: 11,
      value: 'publisher_name',
      label: t('searchReport.dataResult.publisher_name'),
    },
    {
      key: 12,
      value: 'published_date',
      label: t('searchReport.dataResult.published_started_on'),
    },
    {
      key: 13,
      value: 'started_on',
      label: t('searchReport.dataResult.action_on'),
    },
    { key: 14, value: 'comment', label: t('searchReport.dataResult.comment') },
  ]

  const FIELDS_DATE = [
    'started_on',
    'started_on_step',
    'date',
    'checked_date',
    'approval_date',
    'published_date',
  ]

  const [newTasks, setNewTasks] = React.useState<boolean>(true)
  const [canceledTasks, setCanceledTasks] = React.useState<boolean>(false)
  const [closedTasks, setClosedTasks] = React.useState<boolean>(false)

  const [startDateFilter, setStartDateFilter] = React.useState<
    Date | undefined
  >(moment().subtract(3, 'month').toDate())
  const [endDateFilter, setEndDateFilter] = React.useState<Date | undefined>(
    undefined
  )
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const docCodeParam = searchParams.get('docCode')
    if (docCodeParam) {
      setField(mappedFields[3].value)
      setFieldText(docCodeParam)
      findDocumentApproval({
        fieldValue: mappedFields[3].value,
        fieldTextValue: docCodeParam,
      })
    } else {
      findDocumentApproval({})
    }
  }, [])

  useEffect(() => {
    if (isRealoadItemsResult) {
      findDocumentApproval({ itemsResult })
    }
  }, [isRealoadItemsResult])

  useEffect(() => {
    if (docCode) {
      setField(mappedFields[3].value)
      setFieldText(docCode)
      findDocumentApproval({
        fieldValue: mappedFields[3].value,
        fieldTextValue: docCode,
      })
    }
  }, [setDocCode])

  const search = async () => {
    findDocumentApproval({})
  }

  const generateReport = async (id: number, path_file?: string) => {
    try {
      setIsLoading(true)
      if (path_file) {
        const { file } = await getFilesByPaths({ pathPdf: path_file })

        downloadFile(file, extractFileNameByPath(path_file))
      } else {
        const result = await documentPost({ download: id })
        downloadBase64(
          document,
          result.report.name,
          result.report.report,
          atob(result.report.report)
        )
      }
    } catch (error) {
      console.log(error)
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      } else {
        toast({
          title: 'Error',
          description: `${error}`,
          type: 'error',
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  const openHistory = (doc: any) => {
    setAdditionModalIsOpen(true)
    setDoc(doc)
  }

  const openView = (doc: any) => {
    setViewModalIsOpen(true)
    setDoc(doc)
  }

  const redirectDoc = (doc: any) => {
    setStartDateApprovalFlow(doc.filter_header.startDate)
    setEndDateApprovalFlow(doc.filter_header.endDate)
    setProcessOrderItemsApprovalFlow(doc.filter_header.orderProcess)
    setPqLotItemsApprovalFlow(doc.filter_header.pqLot)

    navigate(`/generate-report`, {
      state: {
        docCode: doc.code_view,
        test_name: doc.test_name,
        site: doc.site,
        id_sample: doc.id_sample,
        filter_header: doc.filter_header,
      },
    })
  }

  const setInfoReport = (results: unknown) => {
    if (results?.items?.length > 0) {
      results.items.forEach((item: any) => {
        if (!item.test_type) {
          const test = TESTS.find(
            (elem) =>
              elem.name === item.test_name || elem.namePt === item.test_name
          )
          if (test) item.test_type = test.typeCode
        }
      })
    }
  }

  const findDocumentApproval = async (params: {
    fieldValue?: string
    fieldTextValue?: string
    itemsResult?: any[]
  }) => {
    try {
      setIsLoading(true)
      setItemsResult(undefined)
      const userLocalStorage = localStorage.getItem('cognito:user')
      let userData
      if (userLocalStorage && JSON.stringify(userLocalStorage) !== '{}') {
        userData = JSON.parse(userLocalStorage)
      }

      const result = params.itemsResult
        ? { items: params.itemsResult }
        : await documentApprovalPost({
            list: true,
            closed: closedTasks,
            canceled: canceledTasks,
            open: newTasks,
            user: userData.email,
            startDate: startDateFilter,
            endDate: endDateFilter,
            field: params.fieldValue ?? field,
            fieldText: params.fieldTextValue ?? fieldText,
          })
      // const result = {items: docuemnts.items}

      setInfoReport(result)

      setIsRealoadItemsResult(false)
      setItemsResult(result.items)

      const rows = result.items.map((item: any, index: number) => {
        item.column_report = ''
        const objectRow = {
          ...Object.entries(item).reduce((acc, [key, value]) => {
            if (
              value != null &&
              value != undefined &&
              key !== 'code' &&
              key !== 'code_temporary'
            ) {
              let valueDiv = value
              let newKey = key
              if (key === 'code_view') {
                newKey = 'code'
              }
              if (key === 'action') {
                valueDiv = getActionTranslate(value, currentLanguage)
              }
              if (value && FIELDS_DATE.some((str) => key.includes(str))) {
                valueDiv = moment(value).format(
                  currentLanguage === 'pt-BR'
                    ? 'DD/MM/YYYY HH:mm'
                    : 'MM/DD/YYYY hh:mm:ss A'
                )
              }
              if (key === 'column_report') {
                valueDiv = (
                  <div style={{ whiteSpace: 'nowrap', display: 'flex' }}>
                    <div>
                      <Button
                        onClick={() => openView(item)}
                        variant="secondary-grey"
                        title={t('searchReport.button.view')}
                        size="sm"
                        style={{ margin: '5px' }}
                      >
                        <Icon name="EyeLine" color="neutral-color-80" />
                      </Button>
                    </div>
                    {item.action === 'Aguardando alteração' && (
                      <div>
                        <Button
                          onClick={() => redirectDoc(item)}
                          variant="secondary-grey"
                          title={t('searchReport.button.search_report')}
                          size="sm"
                          style={{ margin: '5px' }}
                        >
                          <Icon name="SearchLine" color="neutral-color-80" />
                        </Button>
                      </div>
                    )}
                    <div>
                      <Button
                        onClick={() =>
                          generateReport(item.document_id, item.path_file)
                        }
                        variant="secondary-grey"
                        title={t('searchReport.button.report')}
                        size="sm"
                        style={{ margin: '5px' }}
                      >
                        <Icon name="DownLoadLine" color="neutral-color-80" />
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => openHistory(item)}
                        variant="secondary-grey"
                        title={t('searchReport.button.view_history')}
                        size="sm"
                        style={{ margin: '5px' }}
                      >
                        <Icon name="HistoryLine" color="neutral-color-80" />
                      </Button>
                    </div>
                  </div>
                )
                acc[newKey] = valueDiv
              } else {
                acc[newKey] = (
                  <div style={{ whiteSpace: 'nowrap' }}>{String(valueDiv)}</div>
                ) as React.ReactNode
              }
            }
            return acc
          }, {}),
          index,
        }
        return objectRow
      })

      setTemplateRowResult(rows)
    } catch (error) {
      console.log(error)
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      } else {
        toast({
          title: 'Error',
          description: `${error}`,
          type: 'error',
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Section.Root>
      <Row>
        <SearchBarContainer>
          <InputDropdown.Root
            value={field}
            onValueChange={(e) => {
              setField(e)
              setFieldText('')
            }}
            trigger={
              <InputDropdown.Trigger
              style={{ fontSize: '0.875rem' }}
                placeholder={t('searchReport.filterSection.field')}
              />
            }
            // defaultValue={selectedNode?.data?.type || whyType}
          >
            <DropdownContent maxHeigth="20rem">
              {mappedFields.map((item) => {
                return (
                  <InputDropdown.Item
                    style={{ fontSize: '0.875rem' }}
                    key={`SelectItem-${item.value}`}
                    value={item.value?.toString()}
                  >
                    {item.label}
                  </InputDropdown.Item>
                )
              })}
            </DropdownContent>
          </InputDropdown.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <TextFieldInput
            fontSize="0.875rem"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setFieldText(event?.target?.value)}
            placeholder={t('', t('searchReport.filterSection.typeField'))}
            width="100%"
            value={fieldText}
          />
        </SearchBarContainer>

        <CheckboxContainer>
          <StyledInputLabel>
            {t('searchReport.filterSection.filter-new')}
          </StyledInputLabel>
          <Checkbox
            key="checkbox-"
            label={t('')}
            checked={newTasks}
            withLabel
            onCheckedChange={() => setNewTasks(!newTasks)}
          />
        </CheckboxContainer>

        <CheckboxContainer>
          <StyledInputLabel>
            {t('searchReport.filterSection.filter-cancelled')}
          </StyledInputLabel>
          <Checkbox
            key="checkbox-"
            label={t('')}
            checked={canceledTasks}
            withLabel
            onCheckedChange={() => setCanceledTasks(!canceledTasks)}
          />
        </CheckboxContainer>

        <CheckboxContainer>
          <StyledInputLabel>
            {t('searchReport.filterSection.filter-closed')}
          </StyledInputLabel>
          <Checkbox
            key="checkbox-"
            label={t('')}
            checked={closedTasks}
            withLabel
            onCheckedChange={() => setClosedTasks(!closedTasks)}
          />
        </CheckboxContainer>

        <SearchBarContainer>
          <DatePicker.Root>
            <DatePicker.Trigger
              label={t<string>('searchReport.filterSection.startDate')}
              value={startDateFilter ? new Date(startDateFilter) : undefined}
            />
            <DatePicker.SingleDayPicker
              onDaySelect={({ selected }) =>
                selected && setStartDateFilter(selected)
              }
              closeOnSelect
            />
          </DatePicker.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <DatePicker.Root>
            <DatePicker.Trigger
              label={t<string>('searchReport.filterSection.endDate')}
              value={endDateFilter ? new Date(endDateFilter) : undefined}
            />
            <DatePicker.SingleDayPicker
              onDaySelect={({ selected }) =>
                selected && setEndDateFilter(new Date(selected))
              }
              closeOnSelect
            />
          </DatePicker.Root>
        </SearchBarContainer>
        <FilterContainer>
          <ButtonContainer width="8rem">
            <StyledButton onClick={() => search()}>
              <StyledTextButton>
                <Icon name="SearchLine" color="white" />
                {t<string>('searchReport.filterSection.search')}
              </StyledTextButton>
            </StyledButton>
          </ButtonContainer>
        </FilterContainer>
      </Row>
      <DataToResult />
      <ViewModal
        isOpen={viewModalIsOpen}
        setIsOpen={setViewModalIsOpen}
        onOutsideClick={() => setViewModalIsOpen(false)}
        doc={doc}
      />
      <HistoryModal
        isOpen={additionModalIsOpen}
        setIsOpen={setAdditionModalIsOpen}
        onOutsideClick={() => setAdditionModalIsOpen(false)}
        doc={doc}
      />
    </Section.Root>
  )
}

export default FilterSection
